import {Component, OnDestroy, OnInit} from '@angular/core';

import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/index';
import * as NavigationActions from './actions/NavigationActions';
import {AppState} from './reducers';
import {getLeftNavOpen, getRightNavOpen} from './reducers/Navigation.Reducer';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import screenfull from 'screenfull';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  public rightNavOpen$: Observable<boolean>;
  public leftNavOpen$: Observable<boolean>;
  public mobileQuery: boolean;
  public fullScreen: boolean;

  constructor(private store: Store<AppState>, private breakPointObserver: BreakpointObserver) {
    this.rightNavOpen$ = this.store.pipe(select(getRightNavOpen));
    this.leftNavOpen$ = store.select(getLeftNavOpen);
    breakPointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
        this.mobileQuery = result.matches;
        if (result.matches) {
          this.store.dispatch(NavigationActions.rightNavigationCloseAction());
          this.store.dispatch(NavigationActions.leftNavigationCloseAction());
        }
      });
  }

  ngOnInit() {
    this.fullScreen = screenfull.isFullscreen;
  }

  updateRightNav() {
    this.store.dispatch(NavigationActions.rightNavigationUpdateAction());
  }

  updateLeftNav() {
    this.store.dispatch(NavigationActions.leftNavigationUpdateAction());
  }

  toggleFullScreen() {
    screenfull.toggle();
    this.fullScreen = !this.fullScreen;
  }

  ngOnDestroy() {
  }
}
